/** RESPONSIBILITY: the home page's latest-sermon panel, pulled live from the channel. */
import type { HomeSermonSection } from '@app/sections';
import { VideoPlayer, YoutubeThumb, useLatestSermons } from '../commons';

export function HomeSermon({ c }: { c: HomeSermonSection }) {
  const [latest] = useLatestSermons();
  if (!latest) return null;

  return (
    <section className="band band-deep">
      <div className="wrap split">
        <VideoPlayer
          url={latest.url}
          title={latest.title}
          picture={<YoutubeThumb url={latest.url} alt={latest.title} className="video-pic" />}
        />
        <div className="stack">
          <p className="eyebrow">{c.heading}</p>
          <h2>{latest.title}</h2>
          {c.linkLabel && <a className="btn btn-light" href={c.linkHref || '#sermons'}>{c.linkLabel}</a>}
        </div>
      </div>
    </section>
  );
}
